import React from "react";
import { Dialog } from "primereact/dialog";
import styled from "styled-components";

export interface ModalProps {
  header?: any;
  content: any;
  footer?: any;
  visible: boolean;
  onHide: () => void;
}

const MyModal = styled(Dialog)`
  width: 50% !important;
  max-height: 77% !important;
  border-radius: 10px;
  .p-dialog-content {
    padding: 0rem 4rem 1rem 4rem;
  }
  .p-dialog-header-icon {
    color: #dd052b !important;
  }

  .p-dialog-header-icon:enabled:hover {
    background: transparent !important;
  }
  .p-dialog-header-icon.p-dialog-header-close.p-link:focus{
    box-shadow:none !important;
    -webkit-box-shadow:none !important;
  }
  @media (max-width: 768px) {
    width: 100vw !important;
    height: 100vh !important;
    max-height: 100% !important;
    .p-dialog-content {
      padding: 0rem 1rem 1rem 1rem;
      height: 100% !important;
    }
  }
`;

const Modal: React.FC<ModalProps> = ({
  header,
  content,
  visible,
  onHide,
  footer,
}) => (
  <MyModal
    header={header}
    footer={footer ? footer : null}
    closable={true}
    visible={visible}
    focusOnShow={false}
    onHide={() => onHide()}
  >
    {content}
  </MyModal>
);

export default Modal;
